import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import client from './client';

type Response = Awaited<ReturnType<typeof client.getParkingRecords>>;

const select = (response: Response) => {
  return response.data.data;
};

export const useGetParkingRecords = (
  options: Omit<UseQueryOptions<Response>, 'queryFn' | 'queryKey'> = {},
) => {
  const { data, ...query } = useQuery({
    ...options,
    queryKey: ['parking-records'],
    queryFn: () => client.getParkingRecords(),
    select,
  });

  return { ...query, parkingRecords: data };
};
